module.exports = __webpack_public_path__ + "static/media/16UNODC30.ba31477f.jpg";